import fetch from '@/utils/fetch';

// 新增课程
export function addMoralEduOLCourse(args) {

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: '/structure/moralEduOLCourse/addMoralEduOLCourse',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 修改课程
export function updateMoralEduOLCourse(args) {

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: '/structure/moralEduOLCourse/updateMoralEduOLCourse',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 删除课程
export function deleteMoralEduOLCourse(args) {
    let params = new URLSearchParams();
    params.append('id', args.id);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLCourse/deleteMoralEduOLCourse',
        method: 'post',
        data: params
    });
}
// 根据课程id获取课程详情
export function getMoralEduOLCourseInfo(args) {
    let params = new URLSearchParams();
    params.append('id', args.id);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLCourse/getMoralEduOLCourseInfo',
        method: 'post',
        data: params
    });
}

// 查询某区的所有课程列表
export function findMoralEduOLCourseList(args) {
    let params = new URLSearchParams();
    params.append('areaCode', args.areaCode);
    params.append('schoolType', args.schoolType);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLCourse/findMoralEduOLCourseList',
        method: 'post',
        data: params
    });
}

// 新增资源
export function addMoralEduOLResource(args) {
    let params = new URLSearchParams();
    // params.append('courseId', args.courseId);
    // params.append('introdution', args.introdution);
    // params.append('resourceLogo', args.resourceLogo);
    // params.append('resourceSize', args.resourceSize);
    // params.append('resourseName', args.resourseName);
    // params.append('status', args.status);
    // params.append('videoId', args.videoId);
    // params.append('videoUrl', args.videoUrl);

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: '/structure/moralEduOLResource/addMoralEduOLResource',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 修改资源
export function updateMoralEduOLResource(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: '/structure/moralEduOLResource/updateMoralEduOLResource',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 根据资源ID获得资源详情
export function getMoralResourceInfo(args) {
    let params = new URLSearchParams();
    params.append('resourceId', args.resourceId);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getMoralResourceInfo',
        method: 'post',
        data: params
    });
}

// 删除资源
export function deleteMoralEduOLResource(args) {
    let params = new URLSearchParams();
    params.append('id', args.id);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/deleteMoralEduOLResource',
        method: 'post',
        data: params
    });
}

// 查询所有的资源列表根据课程id
export function getMoralEduOLResourcePageList(args) {
    let params = new URLSearchParams();
    params.append('courseId', args.courseId);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchTitle', args.searchTitle);
    params.append('searchType', args.searchType);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getMoralEduOLResourcePageList',
        method: 'post',
        data: params
    });
}

// 查询资源的评论列表(分页)
export function findMoralEduOLResourceReplyListByPage(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('resourceId', args.resourceId);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResourceReply/findMoralEduOLResourceReplyListByPage',
        method: 'post',
        data: params
    });
}

// 新增评论   回复评论(增加子评论)
export function addMoralEduOLResourceReply(query) {
    // params.append('content', query.content); //失物申报内容

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: '/structure/moralEduOLResourceReply/addMoralEduOLResourceReply',
        method: 'post',
        data: JSON.stringify(query)
    });
}

// 删除评论
export function deleteMoralEduOLResourceReply(query) {
    let params = new URLSearchParams();
    params.append('id', query.id); //失物申报内容
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResourceReply/deleteMoralEduOLResourceReply',
        method: 'post',
        data: params
    });
}


// 新增资源观看人员.
export function addResourceRead(args) {
    let params = new URLSearchParams();
    params.append('courseId', args.courseId);
    params.append('fromType', args.fromType);
    params.append('resourceId', args.resourceId);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/addResourceRead',
        method: 'post',
        data: params
    });
}

// 新增点赞
export function addResourcePraise(args) {
    let params = new URLSearchParams();
    params.append('resourceId', args.resourceId);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/addResourcePraise',
        method: 'post',
        data: params
    });
}

// 取消点赞
export function delResourcePraise(args) {
    let params = new URLSearchParams();
    params.append('resourceId', args.resourceId);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/delResourcePraise',
        method: 'post',
        data: params
    });
}

// 是否点赞
export function getIsHavePraiseInfo(args) {
    let params = new URLSearchParams();
    params.append('resourceId', args.resourceId);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getIsHavePraiseInfo',
        method: 'post',
        data: params
    });
}

// 获得点赞列表
export function getResourcePraisePageList(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('resourceId', args.resourceId);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getResourcePraisePageList',
        method: 'post',
        data: params
    });
}

// 根据区和学段查询资源列表（分页）
export function getAreaAndSchoolTypeResourcePageList(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getAreaAndSchoolTypeResourcePageList',
        method: 'post',
        data: params
    });
}

// 根据学校ID获得资源列表
export function getSchoolResourcePageList(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchType', args.searchType);
    params.append('searchTitle', args.searchTitle);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getSchoolResourcePageList',
        method: 'post',
        data: params
    });
}

// 根据区域编码查询学校（可根据学段过滤）
export function queryByPostcode(args) {
    let params = new URLSearchParams();
    params.append('learningStages', parseInt(args.learningStages) === 4 ? '47' : args.learningStages);
    // params.append('learningStages', args.learningStages);
    params.append('postcode', args.postcode);

    return fetch({
        url: '/school/queryByPostcode',
        method: 'post',
        data: params
    });
}
// 补发资源
export function reissueResourceToSchool(args) {
    let params = new URLSearchParams();
    params.append('id', args.id);
    params.append('sendSchoolJson', JSON.stringify(args.sendSchoolJson));
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/reissueResourceToSchool',
        method: 'post',
        data: params
    });
}

// 获得用户管理的区域列表
export function getUserManageAreaCodeList() {
    let params = new URLSearchParams();
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLManagerSet/getUserManageAreaCodeList',
        method: 'post',
        data: params
    });
}

// 获得用户管理的区域列表 统计员
export function getUserStaticAreaCodeList() {
    let params = new URLSearchParams();
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLStaticianSet/getUserStaticAreaCodeList',
        method: 'post',
        data: params
    });
}

// 德育学堂-考点直击统计员获得资源列表
export function getStaticianResourcePageList(args) {
    let params = new URLSearchParams();
    params.append('moralType', 1001);
    params.append('areaCode', args.areaCode);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchTitle', args.searchTitle);
    params.append('searchType', args.searchType);

    return fetch({
        url: '/structure/moralEduOLResource/getStaticianResourcePageList',
        method: 'post',
        data: params
    });
}

// 获得用户管理区域下的学校类型列表
export function getUserManageAreaSchoolTypeList(args) {
    let params = new URLSearchParams();
    params.append('areaCode', args.areaCode);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLManagerSet/getUserManageAreaSchoolTypeList',
        method: 'post',
        data: params
    });
}

// 德育学堂-考点直击管理员获得资源列表
export function getManagerResourcePageList(args) {
    let params = new URLSearchParams();
    params.append('areaCode', args.areaCode);
    params.append('moralType', 1001);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchTitle', args.searchTitle);
    params.append('searchType', args.searchType);

    return fetch({
        url: '/structure/moralEduOLResource/getManagerResourcePageList',
        method: 'post',
        data: params
    });
}

// 根据学校ID获得资源列表
export function getSchoolResourceList(args) {
    let params = new URLSearchParams();
    params.append('courseId', args.courseId);
    params.append('moralType', 1001);
    params.append('searchTitle', args.searchTitle);
    params.append('searchType', args.searchType);

    return fetch({
        url: '/structure/moralEduOLResource/getSchoolResourceList',
        method: 'post',
        data: params
    });
}

// 根据课程ID获得课程资源列表

export function getCourseMoralEduOLResourceList(args) {
    let params = new URLSearchParams();
    params.append('courseId', args.courseId);
    params.append('moralType', 1001);
    params.append('status', args.status);

    return fetch({
        url: '/structure/moralEduOLResource/getCourseMoralEduOLResourceList',
        method: 'post',
        data: params
    });
}

/*评论置顶*/
export function commentTop(args){
    let params = new URLSearchParams();
    params.append('replyId',args.replyId);
    params.append('isTop',args.isTop);
    return fetch({
        url:'/structure/moralEduOLResourceReply/commentTop',
        method:'post',
        data:params
    })
}



// WEBPACK FOOTER //
// ./src/api/resourceManagement/resourceManagement.js